import type { PropsWithChildren, ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import LeadScoreTooltipCloseButton from "../LeadScoreTooltipCloseButton/LeadScoreTooltipCloseButton";
import type { ILeadScoreTooltipFooterProps } from "../LeadScoreTooltipFooter/LeadScoreTooltipFooter";
import LeadScoreTooltipLayout from "../LeadScoreTooltipLayout/LeadScoreTooltipLayout";
import LeadScoreTooltipStatusHeader from "../LeadScoreTooltipStatusHeader/LeadScoreTooltipStatusHeader";

interface IProps extends ILeadScoreTooltipFooterProps {
    onClose: VoidFunction;
}

const LeadScoreDefaultTooltipView = ({
    score,
    onClose,
    children,
    ...footerProps
}: PropsWithChildren<IProps>): ReactElement => {
    const header = (
        <Flex justifyContent="space-between">
            <LeadScoreTooltipStatusHeader score={score} />

            <LeadScoreTooltipCloseButton onClose={onClose} />
        </Flex>
    );

    return (
        <LeadScoreTooltipLayout
            {...footerProps}
            score={score}
            header={header}
        >
            {children}
        </LeadScoreTooltipLayout>
    );
};

export default LeadScoreDefaultTooltipView;
